var scope_0 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cdd101d589368d2da7ee0d5d793b2ebb.js').default;
var scope_1 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d77449a780874f6937af06cbcc3726c3.js').default;
var scope_2 = require('/usr/src/app/www/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    